<section class="mx-auto my-28 sm:mt-40 max-w-screen-2xl">
  <div class="w-10/12 mx-auto sm:w-9/12">
    <h2 class="max-w-3xl mb-12">{{ "tdi.optimize.title" | translate }}</h2>
    <div class="flex-row-reverse mt-12 lg:flex gap-3">
      <div class="relative lg:w-1/2 2xl:w-1/3 flex items-center mb-5 xl:mb-0">
        <img
          src="assets/img/Tdi/heatmaps.png"
          alt="VQ-Management"
          class="mx-auto"
        />
      </div>

      <div class="lg:w-1/2 2xl:w-2/3 grid grdi-cols-1 xl:grid-cols-2 gap-9">
        @for (item of ["1", "2", "3", "4"]; track item) {
          <div class="flex">
            <div class="numbers">{{ "0" + item }}</div>
            <div class="vl h-2/3"></div>
            <div class="pl-4">
              <h6>{{ "tdi.optimize.title" + item | translate }}</h6>
              <p
                class="mt-3 text-sm leading-snug"
                [innerHTML]="'tdi.optimize.text' + item | translate"
              ></p>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</section>
